import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { Project, ProjectProps  } from '../stores/project_store';
import useStores from '../hooks/useStores';
// import useAuth from '../hooks/useAuth';
import useUserIdentity from '../hooks/useUserIdentity';

export type ProjectContextType = {
    //myProjects: Project[];
    createProjectByDedicated: (workKey: string, project: ProjectProps) => Promise<ProjectProps | null>;
/*     getMutualsProject: (identityKey: string) => Promise<Project>;
 */
    // fetchUserProjects: (cursor: string) => Promise<void>;
    fetchIdentityProjects: (identityKey: string) => Promise<ProjectProps[] | void>;
    fetchProject(identityKey: string, projectKey: string): Promise<ProjectProps | null>;
    getIdentityProjects: (identityKey: string) => ProjectProps[];
    getProject: (projectKey: string) => Project | undefined;
    createProject: (project: ProjectProps) => Promise<ProjectProps | null>;
    fetchDedicatedIdentityProjects: (assistantIdentityKey: string, identityKey: string) => Promise<ProjectProps[] | void>;
}

export const ProjectContext = React.createContext<ProjectContextType>({
    // myProjects: [] as Project[],
    fetchProject: () => { throw "Not implemented" },
    createProjectByDedicated: () => { throw "Not implemented" },
    /*     getMutualsProject: () => { throw "Not implemented" }, */
    getIdentityProjects: () => { throw "Not implemented" },
    fetchIdentityProjects: () => { throw "Not implemented" },
    // fetchUserProjects: () => { throw "Not implemented" },
    getProject: () => { throw "Not implemented" },
    createProject: () => { throw "Not implemented" },
    fetchDedicatedIdentityProjects: () => { throw "Not implemented" }
});

export const ProjectProvider = observer(({ children }: { children: React.ReactNode }) => {
    const [_, setKnownProjects] = useState<ProjectProps[]>([]);
    const { projectStore } = useStores();
    const { currentIdentity } = useUserIdentity();

    const updateKnownProjects = useCallback((project: ProjectProps | void) => {
        setKnownProjects(projectStore.items);
        return project || null;
    }, [projectStore]);

    // useEffect(() => {
    //     if(currentUser?.key) {
    //         projectStore
    //             .fetchUserProjects()
    //             .then(updateMyProjects);
    //     }
    // }, [currentUser?.key, projectStore, updateMyProjects]);


    useEffect(() => {
        if(!currentIdentity?.uuid) return;
        // console.log("Loading projects");
        projectStore.fetchIdentityProjects(currentIdentity?.uuid)
            .then(updateKnownProjects);
    }, [currentIdentity.uuid, projectStore, updateKnownProjects]);

    /*
    function getUserProjects(userKey: string) {
        return projectStore.getUserProjects(userKey);
    }
     */
    function getProject(projectKey: string) {
        return projectStore.getProject(projectKey);
    }

    function fetchProject(identityKey: string, projectKey: string) {
        return projectStore.fetchProject(identityKey, projectKey);
    }

    function getIdentityProjects(identityKey: string) {
        return projectStore.items.filter((i) => i.identity === identityKey);
    }

    function createProject(project: ProjectProps): Promise<ProjectProps | null>{
        return projectStore.createProject(project).then(updateKnownProjects);
    }

    function createProjectByDedicated(workKey: string, project: ProjectProps): Promise<ProjectProps | null>{
        return projectStore.createProjectByDedicated(workKey, project)
            .then(updateKnownProjects);
    }

    function fetchIdentityProjects(identityKey: string) {
        if(currentIdentity.role == "assistant") {
            return fetchDedicatedIdentityProjects(
                currentIdentity.uuid, identityKey
            );
        }
        return projectStore.fetchIdentityProjects(identityKey);
    }

    function fetchDedicatedIdentityProjects(assistantIdentityKey: string, identityKey: string) {
        return projectStore.fetchDedicatedIdentityProjects(assistantIdentityKey, identityKey);
    }


   const data = {
       //        knownProjects: knownProjects,
        // fetchUserProjects: projectStore.fetchUserProjects,
       getProject,
         fetchProject,
       getIdentityProjects,
        // getUserProjects: getUserProjects,
       createProject,
       createProjectByDedicated,
       fetchIdentityProjects,
       fetchDedicatedIdentityProjects,
/*         getMutualsProject: getMutualsProject
 */    };

    return (
        <ProjectContext.Provider value={data}>{ children }</ProjectContext.Provider>
    );

});
